export default {
  mapLeftClick: {
    placeInfo: 'Ort Details',
    polygonArea: 'Polygon Fläche',
    placeInsidePolygon: 'Ort in "Avoid Polygon"',
    copyLatlng: 'Kopieren in Lat,Long Format',
    copyLnglat: 'Kopieren in Long,Lat Format',
    directionsToClickedPoint: 'Route zum angeklickten Ort',
    latlngCopied: 'Breitengrad und Längengrad kopiert',
    lnglatCopied: 'Längengrad und Breitengrad kopiert'
  }
}
